/**
 * Fixed colors for project status badges and the alerted-card background.
 * These are identical in light and dark themes by requirement — the visual
 * contract for Tenant Improvement project cards does not change with theme.
 */
export const PROJECT_BADGE_TOKENS = {
  on_hold:     { bg: '#FEF3C7', color: '#B45309', border: '#FDE68A' },
  in_progress: { bg: '#D1FADF', color: '#027A48', border: '#A6F4C5' },
  upcoming:    { bg: '#F2F4F7', color: '#344054', border: '#D0D5DD' },
  planning:    { bg: '#DBEAFE', color: '#1D4ED8', border: '#BFDBFE' },
  cancelled:   { bg: '#FEE4E2', color: '#B42318', border: '#FECDCA' },
  at_risk:     { bg: '#FEE4E2', color: '#B42318', border: '#FDA29B' },
  approved:    { bg: '#D1FADF', color: '#027A48', border: '#A6F4C5' },
  completed:   { bg: '#D1FADF', color: '#027A48', border: '#A6F4C5' },
  fallback:    { bg: '#F2F4F7', color: '#344054', border: '#D0D5DD' },
}

export const ALERT_CARD_BACKGROUND = {
  light: '#faf7f7',
  dark: '#2A1B1F',
}

/**
 * Red used on the alert-row badges ("N overdue" / "N need attention") in
 * the Tenant Improvement project cards. Picked specifically for WCAG 2.1
 * AA contrast against white text (≈4.83:1, above the 4.5:1 small-text
 * threshold). The default theme.error.base (#EF4444 / #E52C32) does NOT
 * meet AA for this use, so we pin the color here instead of consuming the
 * theme token.
 */
export const ALERT_BADGE_RED = '#DC2626'
